var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-bar" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          {
            staticClass: "icon nav-toggler",
            on: {
              click: function($event) {
                return _vm.$f.showNav()
              }
            }
          },
          [
            _c("f-sprite-icon", {
              attrs: { "icon-link": _vm.$options.icons.IconNav.id }
            })
          ],
          1
        ),
        _c(
          _vm.$route.name === "MainPage" ? "div" : "a",
          {
            tag: "component",
            staticClass: "logo",
            attrs: { href: _vm.$route.name !== "MainPage" && "/" }
          },
          [
            _c("f-sprite-icon", {
              attrs: { "icon-link": _vm.$options.icons.IconLogo.id }
            })
          ],
          1
        ),
        _c("control-city"),
        _c("a", { staticClass: "link stores", attrs: { href: "/stores" } }, [
          _vm._v("\n      Магазины\n    ")
        ]),
        _c(
          "a",
          { staticClass: "link phone", attrs: { href: "tel:+78007700101" } },
          [_vm._v("\n      8 800 770 01 01\n    ")]
        ),
        _c("vue-client-only", [
          _vm.adaptive.isTablet
            ? _c(
                "div",
                { staticClass: "tablet-menu" },
                [
                  _c("tree-menu", {
                    attrs: { items: _vm.MENU, "max-depth": 1 }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "icons" },
            [
              _vm.adaptive.isDesktop
                ? _c(
                    "div",
                    { staticClass: "icon", on: { click: _vm.$f.toggleSearch } },
                    [
                      _c("f-sprite-icon", {
                        attrs: { "icon-link": _vm.$options.icons.IconSearch.id }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isPromotionsShown ? _c("control-promotions") : _vm._e(),
              _vm.isProfileShown ? _c("control-user") : _vm._e(),
              _vm.isFavoritesShown
                ? _c("control-favorites", { staticClass: "icon" })
                : _vm._e(),
              _vm.isCartShown ? _c("control-cart") : _vm._e()
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }